import script from "./SettingsModal.vue?vue&type=script&setup=true&lang=js"
export * from "./SettingsModal.vue?vue&type=script&setup=true&lang=js"

import "./SettingsModal.vue?vue&type=style&index=0&id=3169d212&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3169d212"]])

export default __exports__